import React from 'react';
import { View, ScrollView, StyleSheet } from 'react-native';
import { REDESIGN_SPACING } from '@/constants/residents/homeConstants';
import { PageHeader } from '../PageHeader';
import { FAQSupportCard } from './FAQSupportCard';
import { FAQAccordionItem } from './FAQAccordionItem';
import { FAQErrorTable } from './FAQErrorTable';
import type { FaqSection } from '@/screens/residents/faq/faq';

const HP = REDESIGN_SPACING.horizontalPadding;

interface FAQContentProps {
  sections: FaqSection[];
  onSupportPress: () => void;
  showCommonErrors?: boolean;
  subtitle?: string;
  contentPaddingBottom?: number;
  testIdPrefix?: string;
}

export const FAQContent: React.FC<FAQContentProps> = React.memo(({
  sections,
  onSupportPress,
  showCommonErrors = false,
  subtitle,
  contentPaddingBottom = 40,
  testIdPrefix = 'FAQ',
}) => (
  <View style={styles.wrapper}>
    <ScrollView
      style={styles.scrollView}
      contentContainerStyle={[styles.scrollContent, { paddingBottom: contentPaddingBottom }]}
      showsVerticalScrollIndicator={false}
    >
      <PageHeader title="FAQ" subtitle={subtitle} />

      <View style={styles.supportCardWrapper}>
        <FAQSupportCard onSupportPress={onSupportPress} />
      </View>

      <View style={styles.accordionList}>
        {sections.map((section, idx) => (
          <FAQAccordionItem
            key={idx}
            section={section}
            index={idx}
            testIdPrefix={testIdPrefix}
            showSeparator={showCommonErrors || idx < sections.length - 1}
          />
        ))}
        {showCommonErrors && <FAQErrorTable />}
      </View>
    </ScrollView>
  </View>
));

FAQContent.displayName = 'FAQContent';

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
  },
  scrollView: {
    flex: 1,
  },
  scrollContent: {
    paddingHorizontal: HP,
  },
  supportCardWrapper: {
    marginTop: 20,
  },
  accordionList: {
    marginTop: 8,
  },
});
